<template>
 <div class="mirror">
   <div class="wrap" :style="{width:width+'px',height:width+'px'}" >
    <div ref="truth" :style="{width:'100%',height:'100%'}" @mousemove="move" @mouseover.stop="showmagnify" @mouseleave="hidemagnify">
    <div class="mask" ref="mask" v-show = "showmask" :style="{width:width/2+'px',height:width/2+'px',left:maskposition.x+'px',top:maskposition.y+'px'}"></div>
      <template v-if="isFromRainBow">
        <img v-if="picSmallList" :src="picSmallList[curThumbIndex].MidPic" draggable="false"/>
        <img v-else :src="piclist[curThumbIndex].MidPic" draggable="false"/>

      </template>
      <template v-else>
        <img  v-if="picSmallList" :src="picSmallList[curThumbIndex]" draggable="false"/>
        <img v-else :src="piclist[curThumbIndex]" draggable="false"/>

      </template>
    </div>
    <div class="virtual" ref="virtual" v-if = "isshowvirtual" :style="{width:width+'px',height:width+'px'}" >
      <div class="big" ref = "bigpic" :style="{position:'absolute',width:2*width+'px',height:2*width+'px',backgroundsize:'100% 100%',backgroundimage:`url(${piclist[curThumbIndex]})`,left:percent.x, top:percent.y}" >
           <template v-if="isFromRainBow">
              <img :src="piclist[curThumbIndex].MidPic"/>
           </template>
           <template v-else>
              <img :src="piclist[curThumbIndex]" draggable="false"/>
           </template>
      </div>
    </div>
   </div>
 </div>
</template>
<script>

export default {
   props:['width','curThumbIndex', 'piclist', 'isFromRainBow','picSmallList'],//宽度是用来给放大镜的
   data(){
    return {
     isshowvirtual:false,
     showmask:false,
     maskposition:{},
     percent:{},
    }
   },
   methods:{
    computedoffset(obj,prop){ //计算元素到body的绝对位置
        if(obj==document.body || obj.offsetParent == document.body){
        return parseInt(obj[prop])
        }
        return parseInt(obj[prop])+this.computedoffset(obj.offsetParent,prop)
  },
    showmagnify(e){
     this.showmask=true;
     this.isshowvirtual = true;
    },
    hidemagnify(){
     this.isshowvirtual = false;
     this.showmask = false
    },
    computeposition(e){
      let x = e.pageX,y = e.pageY;
      let mask = this.$refs.mask;
      let truth = this.$refs.truth;
      let virtual = this.$refs.virtual;
      let bigpic = this.$refs.bigpic;
      x = x - this.computedoffset(truth,'offsetLeft') - mask.offsetWidth/2;
      y = y - this.computedoffset(truth,'offsetTop')- mask.offsetHeight/2;
      if(x <= 0) {
       x=0
      }else if(x>truth.offsetWidth - mask.offsetWidth){
       x = truth.offsetWidth/2
      }
      if(y<=0){
       y=0;
      }
      else if(y>truth.offsetHeight - mask.offsetHeight){
       y = truth.offsetHeight/2
      }

      this.maskposition = {
       x,y
      }
      //计算比例
      this.percent={
       x:-x/(truth.offsetWidth-mask.offsetWidth)*(bigpic.offsetWidth - virtual.offsetWidth)+'px',
       y:-y/(truth.offsetHeight-mask.offsetHeight)*(bigpic.offsetHeight - virtual.offsetHeight)+'px'
      }
    //   console.log( this.percent)
    },
    move(e){
     this.computeposition(e)
    }
  }
  }
</script>
<style lang="scss" scoped>
.now{
 border-color: cyan !important;
}
 .mirror{
  width:100%;
  .wrap{
   user-select: none;
   margin-bottom: 20px;
   position: relative;
   background-color: #fff;
  //  border:1px solid gray;
   box-sizing:border-box;
     cursor: pointer;
    img{
     width:100%;
     height:100%;
    }
    .virtual{

     overflow:hidden;
     width:100%;
     height:100%;
     position:absolute;
     left:calc(100% + 10px);
     top:0;
     z-index: 1000;
     background-repeat:no-repeat
    }
    .mask{
     position: absolute;
     background-color: rgba(255, 255, 255, .5);
    //  background-image: url('https://img.epermarket.com/resource/PoductPicTemp/P322/New.b3a6cc00-415e-4791-a326-82e024d58050M.jpg');
     background-repeat:repeat;
     cursor: move;
    }
  }
  .piclist{
   width:100%;
   display: flex;
   justify-content: space-between;
   flex-wrap:wrap;
   li{
    width:50px;
    height:50px;
    margin:5px;
    border:1px solid transparent;
    box-sizing: border-box;
    img{
     width:100%;
     height:100%
    }
   }
  }
  .piclist:after{
   content:"";
   flex:auto;
  }
 }
</style>


// WEBPACK FOOTER //
// src/components/public/mirror.vue